// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <img src={`/assets/icons/navbar/${name}.png`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'Pregled',
    path: '/dashboard/app',
    icon: icon('dashboard'),
    roles: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_OPERATOR'], // lista dozvoljenih
  },
  {
    title: 'Partneri',
    path: '/dashboard/CompaniesListAll',
    icon: icon('buildings'),
    roles: ['ROLE_SUPERADMIN', 'ROLE_ADMIN'], // lista dozvoljenih
  },
  {
    title: 'Zone',
    path: '/dashboard/ZonesListAll',
    icon: icon('zone'),
    roles: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_OPERATOR'], // lista dozvoljenih
  },
  {
    title: 'Lampe',
    path: '/dashboard/LampsListAll',
    icon: icon('lamp'),
    roles: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_OPERATOR'], // lista dozvoljenih
  },
  {
    title: 'Režimi',
    path: '/dashboard/LightingModesListAll',
    icon: icon('schedule'),
    roles: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_OPERATOR'], // lista dozvoljenih
  },
  {
    title: 'Osoblje',
    path: '/dashboard/WorkersListAll',
    icon: icon('people'),
    roles: ['ROLE_SUPERADMIN'], // lista dozvoljenih
  },
  {
    title: 'Objekti',
    path: '/dashboard/BuildingsListAll',
    icon: icon('buildings'),
    roles: ['ROLE_SUPERADMIN'], // lista dozvoljenih
  },
  {
    title: 'Alarmi',
    path: '/dashboard/AlarmsListAll',
    icon: icon('alarm'),
    roles: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_OPERATOR'], // lista dozvoljenih
  },
  {
    title: 'Izvještaji',
    path: '/dashboard/ReportsListAll',
    icon: icon('alarm'),
    roles: ['ROLE_SUPERADMIN'], // lista dozvoljenih
  },
];

export default navConfig;